// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"1ecb5a46","787":"2d3d3794"}[chunkId] + ".chunk.js";
};